import { PayloadAction } from '@reduxjs/toolkit';
import { SearchState } from '../types';

const toggleShowSearchFiltersReducer = (state: SearchState, action: PayloadAction<boolean | undefined>) => {
  state.showFilters = action.payload !== undefined ? action.payload : !state.showFilters;
};

export default toggleShowSearchFiltersReducer;
